import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import AcceptCookie from "../components/accept-cookie";
import BackToTopButton from "../components/buttons/BackToTopButton";
import { Footer } from "../components/footer";
import { Header } from "../components/header";
import { getSavedLanguage, setLanguage } from "../pages/RootRedirect";

const MainLayout = () => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const currentLang = pathname.split("/")[1];
    if (currentLang !== "vi" && currentLang !== "en") return;

    if (getSavedLanguage() !== currentLang) {
      setLanguage(currentLang);
    }

    if (i18n.language !== currentLang) {
      void i18n.changeLanguage(currentLang);
    }
  }, [i18n, pathname]);

  return (
    <div className="flex min-h-svh flex-col">
      <Header />
      <Outlet />
      <BackToTopButton />
      <Footer />
      <AcceptCookie />
    </div>
  );
};

export default MainLayout;
